import { render, staticRenderFns } from "./PhysicalAddressFieldCard.vue?vue&type=template&id=0cc168ce&"
import script from "./PhysicalAddressFieldCard.vue?vue&type=script&lang=js&"
export * from "./PhysicalAddressFieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports